import { useMemo, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTrafficSource } from './useTrafficSource';

const LEGACY_STORAGE_KEY = 'surveycircle_source';

/**
 * useSurveyCircle — thin backward-compatible wrapper around useTrafficSource.
 * Kept so existing callers (SummaryBlock, LandingPage) keep working unchanged.
 */
export const useSurveyCircle = () => {
  const location = useLocation();
  const traffic = useTrafficSource();

  // Preserve legacy storage key for any older callers still reading it directly.
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get('source') === 'surveycircle') {
      sessionStorage.setItem(LEGACY_STORAGE_KEY, 'true');
    }
  }, [location.search]);

  const isSurveyCircle = useMemo(() => {
    return traffic.isSurveyCircle || sessionStorage.getItem(LEGACY_STORAGE_KEY) === 'true';
  }, [traffic.isSurveyCircle]);

  const surveyCode = 'DGKX-36SP-776Z-636H';
  const redeemUrl = `https://www.surveycircle.com/${surveyCode}/`;

  return { isSurveyCircle, surveyCode, redeemUrl };
};

export const clearSurveyCircleSource = () => {
  sessionStorage.removeItem(LEGACY_STORAGE_KEY);
};
